import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { SchoolSummary } from '@/features/auth/types'

/** Which site this address is — decided by the API from the base domain set in the console. */
export type SiteKind = 'website' | 'platform' | 'school' | 'any' | 'unknown'

export interface SiteContext {
  kind: SiteKind
  baseDomain: string | null
  websiteUrl: string | null
  platformUrl: string
  contactEmail: string | null
  contactPhone?: string | null
  school: SchoolSummary | null
}

export const siteContextQuery = () =>
  queryOptions({
    queryKey: ['site-context'],
    queryFn: () => api.get<SiteContext>('/public/context'),
    staleTime: Infinity,
    retry: 2,
  })

/** "<sub>.<base>" address of a school, when sites have their own domain. */
export function schoolAddress(ctx: Pick<SiteContext, 'baseDomain'>, subdomain: string): string | null {
  if (!ctx.baseDomain) return null
  return `${window.location.protocol}//${subdomain}.${ctx.baseDomain}`
}
